import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import Services from './services';
import { PaginationTotal } from '../../../commons/controls';
import Lib from '../../../commons/lib';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { selectFilter, textFilter } from 'react-bootstrap-table2-filter';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import ProgressButton from '../../../commons/ProgressButton';

class BizonylattipusLista extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      modalRogzit: false,
      modalModosit: false,
      modalTorles: false,
      bizonylattipusJson: [],
      bizonylattipusModositObj: {},
      // enums: [],
      raktarMezo: [],
      raktarMezoInaktiv: true,
      existsRaktar: false,
      statusz: [],
      statuszOptions: [],
      filterOptions: {},
      saveButtonLoading: false,
      modifyButtonLoading: false,
      deleteButtonLoading: false,
    };

    this.iconFormatter = this.iconFormatter.bind(this);
    this.statusFormatter = this.statusFormatter.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.active !== prevProps.active) {
      if (this.props.active) {
        this.updateTable();
      }
    }
  }

    /** Táblázat adatainak frissítése adatbázisból. */
    updateTable = () => {
      Services.listBizonylattipus((err, res) => {
        if (!err) {
          let newArray = res[0].list;
          // Szűkítő feltételek stringgé alakítása
          newArray.forEach((bt) => {
            // INT és BOOLEAN mezők STRING-é alakítása
            for (let b in bt) {
              if (bt.hasOwnProperty(b)) {
                if ((Number(bt[b]) === bt[b] && bt[b] % 1 === 0) || typeof (bt[b]) === 'boolean') {
                  bt[b] = bt[b].toString();
                }
              }
            }
          });

          let filters = {};
          let options = res[0].statusz.map((e) => {
            filters[e.name] = e.caption;
            return <option key={e.name} value={e.name}>{e.caption}</option>;
          });

          this.setState({
            bizonylattipusJson: newArray,
            statusz: res[0].statusz,
            statuszOptions: options,
            filterOptions: filters,
            existsRaktar: res[0].existsraktar
          });
        }
      });
    }

    setExistsRaktar = () => {
      Services.existsRaktar((err, res) => {
        if (!err) {
          this.setState({ existsRaktar: res[0].existsraktar });
        }
      });
    }

    /**
    * Paraméterként kapott bizonylattípus objektum felvétele adatbázisba.
    * @param {SytheticEvent} event
    * @param {object} bizonylattipusObj Bizonylattípus adatokat tartalamzó objektum.
    */
    addBizonylattipus = (event, bizonylattipusObj) => {
      this.setExistsRaktar();
      if (!this.state.existsRaktar) {
        bizonylattipusObj.raktarhozkapcs = false;
      }
      this.setState({ saveButtonLoading: true });
      Services.createBizonylattipus(bizonylattipusObj, (err) => {
        if (!err) {
          this.toggleRogzit();
          this.updateTable();
          this.props.globals.addSuccess('Bizonylattípus felvéve!');
          this.setState({ saveButtonLoading: false });
        }
      });
    }

    /**
    * Paraméterként kapott bizonylattípus objektum módosítása adatbázisba.
    * @param {SytheticEvent} event
    * @param {object} bizonylattipusObj Bizonylattípus adatokat tartalamzó objektum.
    */
    modifyBizonylattipus = (event, bizonylattipusObj) => {
      this.setExistsRaktar();
      if (!this.state.existsRaktar) {
        bizonylattipusObj.raktarhozkapcs = false;
      }
      bizonylattipusObj.id = this.state.bizonylattipusModositObj.id;
      bizonylattipusObj.raktarhozkapcs = this.state.bizonylattipusModositObj.raktarhozkapcs;
      this.setState({ modifyButtonLoading: true });
      Services.updateBizonylattipus(bizonylattipusObj, (err) => {
        if (!err) {
          this.toggleModosit();
          this.updateTable();
          this.props.globals.addSuccess('Bizonylattípus módosítva!');
          this.setState({ modifyButtonLoading: false });
        }
      });
    }

    /**
    * Paraméterként kapott Bizonylattípus id törlése adatbázisban
    * @param {int} id
    */
    deleteBizonylattipus = (id) => {
      this.toggleTorles();
      this.setState({ deleteButtonLoading: true });

      Services.deleteBizonylattipus(id, (err) => {
        if (!err) {
          this.updateTable();
          this.props.globals.addSuccess('Bizonylattípus törölve!');
          this.setState({ deleteButtonLoading: false });
        }
      });
    }

    toggleRogzit = () => {
      this.setState({
        modal: !this.state.modal
      });
    }

    toggleModosit = () => {
      this.setState({
        modalModosit: !this.state.modalModosit
      });
    }

    toggleTorles = () => {
      this.setState({
        modalTorles: !this.state.modalTorles
      });
    }

    handleInputChange = (e) => {
      const { target } = e;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const { name } = target;
      this.setState((prevState) => {
        let bizonylattipusModositObj = prevState.bizonylattipusModositObj;
        bizonylattipusModositObj[name] = value;
        return { bizonylattipusModositObj };
      });
    }

    handleEditClick = (id) => {
      this._currentEditId = id;
      Services.getBizonylattipus(id, (err, res) => {
        if (!err) {
          this.setState({
            bizonylattipusModositObj: res[0]
          });
        }
      });
      this.setExistsRaktar();
      this.toggleModosit();
    }

    handleDeleteClick = (id) => {
      this._currentDeleteId = id;
      // this.getEnums();
      this.toggleTorles();
    }

    /**
    * Visszaadja a bizonylattípushoz tartozó státus jelvényeket.
    * @param {boolean} cell - Cella adatot tartalmazó szöveg.
    * @return {ReactElement} Státusz jelvényt tartalmazó react objektum.
    */
    statusFormatter = (cell) => {
      let statusz = this.state.statusz.find(x => x.name === cell);
      return statusz ? <span className={'badge badge-' + statusz.bagde}>{statusz.caption}</span> : 'N/A';
    }

    iconFormatter = (cell) => {
      return (
        <div>
          {
            this.props.globals.hasRole(['BIZONYLAT_TIPUS'], true) && (
            <React.Fragment>
              <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'modositas'} delay={0}>
                Módosítás
              </UncontrolledTooltip>
              <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleDeleteClick(cell)} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'torles'} delay={0}>
                Törlés
              </UncontrolledTooltip>
            </React.Fragment>
          )}
        </div>
      );
    }

    /**
    * Visszaadja a raktarhozkapcs tartozó státus jelvényeket.
    * @param {boolean} cell - Cella adatot tartalmazó szöveg.
    * @return {ReactElement} Státusz jelvényt tartalmazó react objektum.
    */
    raktarhozkapcsFormatter(cell) {
      if (cell == 'true') return <span className="badge badge-success">Igen</span>;
      if (cell == 'false') return <span className="badge badge-default">Nem</span>;
    }

    render() {
      const options = {
        sizePerPage: 5,
        showTotal: true,
        paginationTotalRenderer: PaginationTotal,
        sizePerPageList: [{
          text: '5', value: 5
        }, {
          text: '10', value: 10
        }, {
          text: '25', value: 25
        }],
      };

      const modifyObj = this.state.bizonylattipusModositObj;
      modifyObj.raktarhozkapcs = '' + modifyObj.raktarhozkapcs;

      const columns = [
        {
          dataField: 'azonosito',
          text: 'Azonosító',
          filter: textFilter({
            delay: 400,
            placeholder: 'Keresés...',
          }),
          sort: true
        },
        {
          dataField: 'nev',
          text: 'Bizonylattípus neve',
          filter: textFilter({
            delay: 400,
            placeholder: 'Keresés...',
          }),
          sort: true
        },
        {
          dataField: 'raktarhozkapcs',
          text: 'Raktárhoz kapcsolódik?',
          formatter: this.raktarhozkapcsFormatter,
          filter: selectFilter({
            options: { true: 'Igen', false: 'Nem' },
            placeholder: 'Összes',
          }),
          align: 'center',
          sort: true,
          hidden: !this.state.existsRaktar
        },
        {
          dataField: 'statusz',
          text: 'Státusz',
          formatter: this.statusFormatter,
          filter: selectFilter({
            options: this.state.filterOptions,
            placeholder: 'Összes',
            condition: 'eq'
          }),
          align: 'center',
          sort: true
        },
        {
          dataField: 'id',
          text: 'Műveletek',
          formatter: this.iconFormatter,
          hidden: !this.props.globals.hasRole(['BIZONYLAT_TIPUS'], true)
        },
      ];

      return (
        <div>
          {
            this.props.globals.hasRole(['BIZONYLAT_TIPUS'], true) && (
            <div className="row">
              <div className="col-sm-12">
                <Button className="pull-left table-new-button" color="primary" onClick={this.toggleRogzit}>Új bizonylattípus</Button>
              </div>
            </div>
          )}

          <BootstrapTable
            bootstrap4
            keyField="id"
            columns={columns}
            data={this.state.bizonylattipusJson}
            filter={filterFactory()}
            pagination={paginationFactory(Lib.bootstraptableProps)}
          />

          {/* Felvitel BEGIN */}
          <Modal isOpen={this.state.modal} toggle={this.toggleRogzit} className={this.props.className}>
            <RFForm onSubmit={this.addBizonylattipus} /* Ha kell default érték! initialValues={{ raktarhozkapcs: "true" }} */ >
              <ModalHeader toggle={this.toggleRogzit}>Bizonylattípus felvétel</ModalHeader>
              <ModalBody>
                <div>
                  <RFField label={'Bizonylattípus azonosító:'} name="azonosito" id="azonosito" maxLength="10" required />
                </div>
                <div>
                  <RFField label={'Bizonylattípus megnevezése:'} name="nev" id="nev" maxLength="50" required />
                </div>
                {this.state.existsRaktar && (
                  <div style={{ marginBottom: 6 }}> 
                    <span>Raktárhoz kapcsolódó: *</span>
                      <RFField
                        name="raktarhozkapcs"
                        component="input"
                        type="radio"
                        value="true"
                        label="Igen"
                      />{' '}
                      <RFField
                        name="raktarhozkapcs"
                        component="input"
                        type="radio"
                        value="false"
                        label="Nem"
                      />{' '}
                  </div>
                )}
                <Row>
                  <Col md={12}>
                    <RFField
                      type="select"
                      name="statusz"
                      label="Státusz"
                      value="AKTIV"
                      errorMessage="Kötelező mező!"
                      required
                      selectOptions={this.state.statuszOptions}
                    />
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <ProgressButton color="primary" type="submit" loading={this.state.saveButtonLoading}>Mentés</ProgressButton>{' '}
                <Button type="button" color="secondary" onClick={this.toggleRogzit}>Mégsem</Button>
              </ModalFooter>
            </RFForm>
          </Modal>
          {/* Felvitel END */}

          {/* Módosítás BEGIN */}
          <Modal isOpen={this.state.modalModosit} toggle={this.toggleModosit} className={this.props.className} backdrop="static" size="md">
            <RFForm onSubmit={this.modifyBizonylattipus}>
              <ModalHeader>Bizonylattípus módosítás</ModalHeader>
              <ModalBody>
                <div>
                  <RFField label={'Bizonylattípus azonosító:'} name="azonosito" id="azonosito" value={modifyObj.azonosito} maxLength="10" required disabled />
                </div>
                <div>
                  <RFField label={'Bizonylattípus megnevezése:'} name="nev" id="nev" value={modifyObj.nev} maxLength="50" required />
                </div>
                {this.state.existsRaktar && (
                  <div style={{ marginBottom: 6 }}>
                    <span>Raktárhoz kapcsolódó: *</span>
                    <RFField
                      name="raktarhozkapcs"
                      component="input"
                      type="radio"
                      onChange={this.handleInputChange}
                      checked={modifyObj.raktarhozkapcs === "true"}
                      value="true"
                      label="Igen"
                    />{' '}
                    <RFField
                      name="raktarhozkapcs"
                      component="input"
                      type="radio"
                      onChange={this.handleInputChange}
                      checked={modifyObj.raktarhozkapcs === "false"}
                      value="false"
                      label="Nem"
                    />{' '}
                  </div>
                )}
                <Row>
                  <Col md={12}>
                    <RFField
                      type="select"
                      name="statusz"
                      value={modifyObj.statusz}
                      label="Státusz"
                      errorMessage="Kötelező mező!"
                      required
                      selectOptions={this.state.statuszOptions}
                    />
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <ProgressButton color="primary" loading={this.state.modifyButtonLoading}>Mentés</ProgressButton>{' '}
                <Button type="button" color="secondary" onClick={this.toggleModosit}>Mégsem</Button>
              </ModalFooter>
            </RFForm>
          </Modal>
          {/* Módosítás END */}

          {/* Törlés BEGIN */}
          <Modal isOpen={this.state.modalTorles} toggle={this.toggleTorles} className={this.props.className}>
            <ModalHeader toggle={this.toggleTorles}>Törlés</ModalHeader>
            <ModalBody>
                          Valóban törölni kívánod a kiválasztott tételt?
            </ModalBody>
            <ModalFooter>
              <ProgressButton color="primary" onClick={() => this.deleteBizonylattipus(this._currentDeleteId)} loading={this.state.deleteButtonLoading}>OK</ProgressButton>
              <Button type="button" color="secondary" onClick={this.toggleTorles}>Mégsem</Button>
            </ModalFooter>
          </Modal>
          {/* Törlés END */}

        </div>
      );
    }
}

BizonylattipusLista.propTypes = {
  globals: PropTypes.object,
  active: PropTypes.bool,
  className: PropTypes.string
};

export default BizonylattipusLista;
